// extracted by mini-css-extract-plugin
export default {"button":"AuthenticateLanding_button__3BkuC"};